// extracted by mini-css-extract-plugin
module.exports = {"table":"kennysCabin_table__vKPkx","img":"kennysCabin_img__1nqw6","map":"kennysCabin_map__2riNE","td-split":"kennysCabin_td-split__3Y_3y"};